import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-days',
  components: {},
})
export default class DisplayFieldDays extends mixins(AbstractDisplayField) {}
